import { supabase } from "../supabaseClient";

const TABLE = "AllotmentLetterTemplate";

/**
 * Fetch the template for a given project + wing combination.
 * Wing-specific templates take precedence over project-level templates.
 * Returns null if no template is found.
 */
export async function getTemplateForAllotment(projectId, wingId = null) {
  // Try wing-specific template first
  if (wingId) {
    const { data: wingTemplate, error } = await supabase
      .from(TABLE)
      .select("*")
      .eq("project_id", projectId)
      .eq("wing_id", wingId)
      .maybeSingle();

    if (!error && wingTemplate) return wingTemplate;
  }

  // Fall back to project-level template
  const { data, error } = await supabase
    .from(TABLE)
    .select("*")
    .eq("project_id", projectId)
    .is("wing_id", null)
    .maybeSingle();

  if (error) {
    console.error("Error fetching allotment letter template:", error.message);
    return null;
  }

  return data;
}

export async function getTemplatesForProject(projectId) {
  const { data, error } = await supabase
    .from(TABLE)
    .select("*")
    .eq("project_id", projectId)
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching templates for project:", error.message);
    return [];
  }
  return data || [];
}

export async function getAllTemplates() {
  const { data, error } = await supabase
    .from(TABLE)
    .select("*")
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching templates:", error.message);
    return [];
  }
  return data || [];
}

export async function saveTemplate(template) {
  if (template.id) {
    const { id, created_at, ...fields } = template;
    const { data, error } = await supabase
      .from(TABLE)
      .update(fields)
      .eq("id", id)
      .select()
      .single();

    if (error) throw error;
    return data;
  } else {
    const { data, error } = await supabase
      .from(TABLE)
      .insert([template])
      .select()
      .single();

    if (error) throw error;
    return data;
  }
}

export async function deleteTemplate(id) {
  const { error } = await supabase.from(TABLE).delete().eq("id", id);
  if (error) throw error;
}
